module.exports = __webpack_public_path__ + "img/wt.0772d4f4.png";